<div class="spinner-wrapper" *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>

<div class="col-12 text-center mt-5" [ngSwitch]="errorType">
  <div *ngSwitchCase="'genericError'">
    <h3 *ngIf="!hatKredit" appTranslationModal [translate]="'ERRORPAGE.Error'"></h3>
    <h3 *ngIf="hatKredit" appTranslationModal>{{ genericErrorMsg }}</h3>
    <p *ngIf="hatKredit" appTranslationModal [translate]="'ERRORPAGE.Versuch3'"></p>
  </div>

  <div *ngSwitchCase="'noResult'">
    <p appTranslationModal [translate]="'ERRORPAGE.NO_RESULT'"></p>
  </div>

  <div *ngSwitchCase="'notAccepted'">
    <h3 appTranslationModal [translate]="'ERRORPAGE.NOT_ACCEPTED'"></h3>
    <p appTranslationModal [translate]="'ERRORPAGE.NOT_ACCEPTED_SUBTEXT'"></p>
  </div>

  <div *ngSwitchCase="'identityError'">
    <h3 appTranslationModal [translate]="'ERRORPAGE.NO_IDENTITY'"></h3>
    <p appTranslationModal [translate]="'ERRORPAGE.NO_IDENTITY_SUBTEXT'"></p>
  </div>

  <div *ngSwitchCase="'lastIdentityError'">
    <h3 appTranslationModal [translate]="'ERRORPAGE.LAST_NO_IDENTITY'"></h3>
    <p appTranslationModal [translate]="'ERRORPAGE.LAST_NO_IDENTITY_SUBTEXT'"></p>
  </div>

  <div *ngSwitchDefault>
    <p>An unexpected error occurred.</p>
  </div>
</div>

<div class="col-12 text-center mt-5" style="display: flex; flex-direction: row; justify-content: space-around">
  <app-button (click)="goBack()" [disabled]="canBeDisabled" color="accent">Abbrechen</app-button>

  <app-button *ngIf="errorType === 'genericError'" [disabled]="canBeDisabled" (click)="acceptOffer()" color="accent">
    Weiter
  </app-button>
</div>
